import React from 'react';
import { Button } from 'react-bootstrap';

const SecondaryButton = (props) => {
    const { onClick, disabled, text } = props;
    return (
        <Button className={`action-btn-light create-btn-light`} disabled={disabled} onClick={onClick}>
            <span className={`btn-inner btn-inner-light-${!disabled ? "enabled" : "disabled"}`}>
                {text == "Archive" && <span className={`icon-size archive-icon-white-${!disabled ? "enabled" : "disabled"}`}></span>}
                {text}
            </span>
        </Button>
    )
}

export default SecondaryButton;